import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { TStencilStore } from '../../../types/Stencil';
import { setAuthorEmail } from '../../../actions/stencils/editor';

function Email(): React.ReactElement {
  const email = useSelector(
    (state: TStencilStore) => state.submission.authorEmail
  );
  const dispatch = useDispatch();
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        e.preventDefault();
      }
    },
    []
  );
  const handleChange = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      dispatch(setAuthorEmail(e.currentTarget.value));
    },
    [dispatch]
  );

  return (
    <div className="c-form-group">
      <label className="c-form-label" htmlFor="stencil_author_email">
        Email
      </label>
      <p className="c-form-helper">
        This is required for us to send your confirmation that your contribution
        has been successfully submitted.
      </p>
      <input
        placeholder="william@riker.com"
        className="c-form-input"
        type="email"
        id="stencil_author_email"
        value={email}
        required
        onKeyDown={handleKeyDown}
        onChange={handleChange}
      />
    </div>
  );
}

export default Email;
